import { loadStripe, Stripe } from '@stripe/stripe-js'

let stripePromise: Promise<Stripe | null> | null = null

/**
 * Lazily loads and memoises the Stripe.js client using the publishable key.
 * Shared by identity verification and the embedded rent payment page. Returns
 * null when the key isn't configured so callers can fall back to a friendly
 * unavailable state (or the hosted Checkout flow) instead of throwing.
 *
 * @returns {Promise<Stripe | null>}
 */
const getStripeClient = (): Promise<Stripe | null> => {
  const publishableKey = (
    import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? ''
  ).trim()

  if (publishableKey === '') {
    return Promise.resolve(null)
  }

  if (stripePromise === null) {
    stripePromise = loadStripe(publishableKey)
  }

  return stripePromise
}

export { getStripeClient }
